<template>
  <div>
    <div class="loginFormStyle">
      <div class="loginRowStyle">
        <div class="columnStyle">
          <div><img src="https://www.sales1.top/score/images/banner.png" /></div>
          <div class="imageStyle">
            <div class="imgItemStyle"><img src="https://www.sales1.top/score/images/public_num.jpg" width="150px;" />
              <div>微信扫码关注公众号</div>
            </div>
            <div class="imgItemStyle"><img src="https://www.sales1.top/score/images/weixin.jpg" width="150px;" />
              <div>微信扫码打开查询端</div>
            </div>
            <div class="imgItemStyle"><img src="https://www.sales1.top/score/images/QQ.png" width="150px;" />
              <div>QQ扫码打开查询端</div>
            </div>
          </div>
        </div>
        <div>
          <el-card class="box-card">
            <div slot="header" class="clearfix titleBoxStyle">
              <div>
                <div style="font-size: 20px;" align="center">快查成绩·学生成绩单<br /><span
                    style="font-weight: bold;font-size:40px ;">成绩发布平台</span></div>
              </div>
            </div>
            <div>
              <el-row>
                <el-form :model="loginForm" status-icon ref="loginForm" label-width="100px" class="demo-ruleForm">
                  <el-form-item label="手机号" prop="username">
                    <el-input type="text" v-model="loginForm.username" autocomplete="off" placeholder="输入手机号,和手机端相同">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')"
                      autocomplete="off" placeholder="输入密码,和手机端相同"></el-input>
                  </el-form-item>
                  <div @click="showWanSearch"
                    style="text-decoration: underline;color:red;text-align: center;margin: 10px;padding-left: 100px;font-size: 12px;cursor: pointer;">
                    发分班、核对资料、打分测评，用老师专用小程序点我了解</div>
                  <el-form-item class="btnActionStyle">

                    <div style="margin-top:10px;">
                      <el-tooltip class="item" effect="dark"
                        content="点这个按钮无反应应该是浏览器兼容模式问题,登录前,请将浏览器切换成'高速模式',切换方法见登录按钮下方帮助" placement="bottom">
                        <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
                      </el-tooltip>
                      <el-button @click="resetForm('loginForm')">重填</el-button>
                    </div>
                  </el-form-item>
                </el-form>
              </el-row>
              <el-row class="registerStyle">
                <el-button @click="forgotPassword" type="text" size="medium">
                  忘记密码怎么办?
                </el-button>
              </el-row>
              <el-row class="registerStyle">
                <el-button @click="registeTeacher" type="text" size="medium">
                  点击免费注册教师账号
                </el-button>
              </el-row>
              <el-row class="registerStyle">
                <el-button @click="howToSwitch" type="text" size="medium">
                  如何将浏览器切换成"高速模式"或"快速模式"
                </el-button>
              </el-row>

            </div>
          </el-card>
        </div>
      </div>

    </div>
    <div>
      <div style="text-align: center;margin-top: 50px;font-size: 16px;"><span>客服微信:wx34424698</span><span
          style="padding-left:10px;">客服QQ:34424698</span>
        <div
          style="padding-top:10px;font-size: 14px;display: flex;justify-content: center;align-items: center;margin-bottom: 50px;">
          <span>智韬科技</span>
          <span style="margin-left:20px;display: flex;justify-content: center;align-items: center;">ICP备案号:<a
              href="https://beian.miit.gov.cn" target="_blank">陇ICP备19004729号-1</a></span>
          <span style="margin-left:20px;display: flex;justify-content: center;align-items: center;">
            <img src="https://www.sales1.top/score/images/gongan_beian_logo.png" style="width:20px;height:20px;" />
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=62010202004353" rel="noreferrer"
              target="_blank">甘公网安备62010202004353号</a>
          </span>
        </div>
      </div>
    </div>

    <!--模式切换帮助-->
    <el-dialog width="80%" :close-on-click-modal="false" title="如何切换浏览器的模式" :visible.sync="browserSwitchDialogVisible">
      <div class="colStyle">

        如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
        <br /><br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        正确的应该是如下图所示：
        <br /><br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!--显示万能快查-->
    <el-dialog width="60%" :close-on-click-modal="false" title="老师专用小程序" :visible.sync="wanSearchVisible">
      <div style="display: flex;justify-content: space-evenly;">
        <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">发分班、发成绩</div>
          <div
            style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
          </div>
          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">万能快查小程序</div>
          <div style="display: flex;justify-content: center;"><img src="../assets/wansearch_weixin.jpg"
              style="width: 150px;height:150px;"></img></div>
          <div style="font-weight: bold;margin-top: 10px;">
            <!--            <div style="margin-bottom: 5px;">用途：可设置任意查询条件的查询系统</div> -->
            <div style="margin-bottom: 5px;">特点：</div>
            <div style="margin-bottom: 5px;">1.查询条件可以任意设置</div>
            <div style="margin-bottom: 5px;">2.适用于发分班、工资条等</div>
            <div style="margin-bottom: 5px;">3.可加入公众号，海报等</div>
          </div>
        </div>

        <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">核对数据、补填资料
          </div>
          <div
            style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
          </div>

          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">核对信息小程序</div>
          <div style="display: flex;justify-content: center;"><img src="../assets/hdxx_qrcode.jpg"
              style="width: 150px;height:150px;"></img></div>
          <div style="font-weight: bold;margin-top: 10px;">
            <!-- <div style="margin-bottom: 5px;">用途：可核对任何Excel文件中数据</div> -->
            <div style="margin-bottom: 5px;">特点：</div>
            <div style="margin-bottom: 5px;">1.一对一核对安全保密</div>
            <div style="margin-bottom: 5px;">2.可补填、可修改，修改可留痕</div>
            <div style="margin-bottom: 5px;">3.查询条件可任意定制</div>
          </div>
        </div>

        <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">评价打分、民主测评
          </div>

          <div
            style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
          </div>

          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">打分测评小程序</div>
          <div style="display: flex;justify-content: center;"><img src="../assets/dfcp_qrcode.jpg"
              style="width: 150px;height:150px;"></img></div>
          <div style="font-weight: bold;margin-top: 10px;">
            <!-- <div style="margin-bottom: 5px;">用途：比赛打分、评价打分、民主测评</div> -->
            <div style="margin-bottom: 5px;">特点：</div>
            <div style="margin-bottom: 5px;">1.一对一打分安全保密</div>
            <div style="margin-bottom: 5px;">2.可实名、可匿名</div>
            <div style="margin-bottom: 5px;">3.打分结果自动计算汇总</div>
          </div>
        </div>

        <div class="colStyle" style="border: 1px solid lightgray;padding:20px;width: 250px;margin-right: 10px;">
          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:red;">在线收集、学籍填报
          </div>

          <div
            style="font-weight: bold;display: flex;justify-content: center;font-size: 16px;color:#409EFF;padding:5px;">用
          </div>

          <div style="font-weight: bold;display: flex;justify-content: center;font-size: 22px;">多人填表小程序</div>
          <div style="display: flex;justify-content: center;"><img src="../assets/drtb_qrcode.jpg"
              style="width: 150px;height:150px;"></img></div>
          <div style="font-weight: bold;margin-top: 10px;">
            <!-- <div style="margin-bottom: 5px;">用途：比赛打分、评价打分、民主测评</div> -->
            <div style="margin-bottom: 5px;">特点：</div>
            <div style="margin-bottom: 5px;">1.互不查看，安全保密</div>
            <div style="margin-bottom: 5px;">2.只填自己的，防止改错</div>
            <div style="margin-bottom: 5px;">3.数据格式规范，一键导出</div>
          </div>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wanSearchVisible=false">我知道了</el-button>
      </div>
    </el-dialog>


    <!--显示修改密码-->
    <el-dialog width="40%" :close-on-click-modal="false" title="如何修改密码" :visible.sync="resetPasswordVisible">
      <div>
        <div style="font-weight: bold;text-align: center;">修改密码请用快查成绩微信小程序,扫码打开:</div>
        <div style="display: flex;justify-content: center;"><img src="/score/images/weixin.jpg"
            style="width: 200px;height: 200px;"></img></div>
        <div style="font-weight: bold;text-align: center;">扫码打开小程序后找到“发布成绩”标签,点击“忘记密码?点我重设”</div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resetPasswordVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        browserSwitchDialogVisible: false,
        wanSearchVisible: false,
        resetPasswordVisible: false,
        loginForm: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      submitForm(formName) {
        let that = this

        if (this.loginForm.username === '') {
          that.$message.error('请输入手机号')
          return
        }

        if (this.loginForm.password === '') {
          that.$message.error('请输入密码')
          return
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var tmpUsername = that.loginForm.username.trim()
        var tmpPassword = that.loginForm.password.trim()

        var requestUrl = '/score/web/_login.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: tmpUsername,
              password: tmpPassword
            }
          }).then(function(response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '0') {

              that.$session.set('USERNAME', tmpUsername) // 存session
              that.$session.set('TEACHER_NAME', response.data.data.teacher_name) // 存session
              that.$session.set('SCHOOL', response.data.data.school_name) // 存session

              // that.$router.push('/exam_list')

              that.$router.push({
                path: '/exam_list',
                params: {
                  username: that.loginForm.username
                }
              })
            } else {
              var tip = response.data.password_tip
              if (tip === '') {
                that.$message.error('账号错误,登录失败！')
              } else {
                that.$message.error('密码错误,登录失败！密码提示:' + tip)
              }
            }

            load.close()
          })
          .catch(err => {
            that.$message.error('登录失败，网络异常请稍后重试！')
            console.log(err)
            load.close()
          })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      registeTeacher() {
        this.$router.push('/registe_teacher')
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      enterFun() {

        // this.submitForm('loginForm')
      },
      forgotPassword() {
        // this.$message.error('请用手机端快查成绩小程序重新设置密码!')
        this.resetPasswordVisible = true
      },
      showWanSearch() {
        this.wanSearchVisible = true
      }
    }
  }
</script>

<style>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
  }

  .loginFormStyle {
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }

  .titleBoxStyle {
    display: flex;
    justify-content: center;
  }

  .titleBoxStyle span {
    font-size: 30px;
    font-weight: bold;
  }

  .btnActionStyle {
    display: flex;
    justify-content: center;
  }

  .registerStyle {
    display: flex;
    justify-content: center;
  }

  .loginRowStyle {
    display: flex;

  }

  .imageRowStyle {
    display: flex;
    flex-direction: row;
  }

  .columnStyle {
    display: flex;
    flex-direction: column;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue